import { render, staticRenderFns } from "./AlertMapping.vue?vue&type=template&id=bb5ddb8a&"
import script from "./AlertMapping.vue?vue&type=script&lang=js&"
export * from "./AlertMapping.vue?vue&type=script&lang=js&"
import style0 from "./AlertMapping.vue?vue&type=style&index=0&id=bb5ddb8a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports